module.exports = __webpack_public_path__ + "img/blank-release.2d95a326.png";